import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-stop-icon',
  templateUrl: 'stop-icon.component.html'
})
export class StopIconComponent {
  constructor() {}
}
